import * as React from 'react';
import { FC } from 'react';
import { UserMenu } from 'moduleBase/types/Menu';
import { BLOCK_ID_USER_ACTIONS, BLOCK_ID_USER_AUTH, BLOCK_ID_USER_MAIN } from 'moduleBase/constants/menu';
import { ProfileInfo } from 'moduleBase/components/header/profile/ProfileInfo';
import { Menu } from 'moduleBase/components/header/profile/Menu';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import { transformMenuBlockData } from './helpers';
import { LangsMenu } from '../LangsMenu/LangsMenu';
import Actions from '../Actions/Actions';

type PropsType = {
  userMenu: UserMenu,
  hide: () => void,
};

const ProfileInfoContent: FC<PropsType> = ({ userMenu, hide }) => {
  const [submenu, setSubmenu] = React.useState(false);
  const isDesktop = useMediaIsDesktop();

  return (
    <>
      <ProfileInfo />
      <div className="dropdown-flat-list">
        <Menu block={transformMenuBlockData(userMenu, BLOCK_ID_USER_MAIN)} hide={hide} />
        <LangsMenu submenu={submenu} setSubmenu={setSubmenu} />
        {!isDesktop
          ? <Actions hide={hide} frozen={userMenu.frozen} wait={userMenu.wait} action={userMenu.action} /> : null}
      </div>
      <div className="dropdown-flat-list">
        <Menu block={transformMenuBlockData(userMenu, BLOCK_ID_USER_ACTIONS)} hide={hide} />
      </div>
      <div className="dropdown-flat-list">
        <Menu
          block={transformMenuBlockData(userMenu, BLOCK_ID_USER_AUTH)}
          hide={hide}
          itemClassName="dropdown-flat-list__item_light"
        />
      </div>
    </>
  );
};

export { ProfileInfoContent };
